export const ERROR_TEXT = {
  qrCodeReadingFailure: 'QRコードの読み取りに失敗しました。\n再度お試しください。',
  receptionFailure: '受付処理に失敗しました。\n係の者にお伝えください。'
};
